import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SimCard } from '@phosphor-icons/react';
import { useUser } from '../context/User';
import { NavItem } from '../interfaces/NavBar';

export const useMyEsimItem = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  const myESIM: NavItem = useMemo(
    () => ({
      id: '1',
      label: t('navbar.my_esim', 'My eSIM'),
      to: '/orders',
      ecommerceRoute: true,
      visible: !!user,
      'data-testid': 'link-my-eSIM',
      icon: <SimCard size={24} />,
    }),
    [user],
  );

  return myESIM;
};
